import { SearchObject } from "app/common/Model/SearchObject";
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";

import { PROMOTION_DEFAULT_CODE, SELECT_ALL_ITEM_FEE } from "app/appConfig";
import {
  LEAD_SOURCE_LEVEL,
  PAGESIZE_ALL,
  PAYMENT_METHOD_CHARACTERISTIC_CASH_CODE,
  PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_LOYALTY,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE,
  PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD,
  TYPE_CARD,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
  VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { getCurrentStaff, getPromotionCodes, roundVnd } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import { getListCode } from "app/services/CustomerSourceService";
import { getFileById } from "app/services/FileDescriptionExtService";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import {
  getInvoiceItemByType,
  lockOrder,
} from "app/services/InvoiceItemService";
import { invoiceGenerateQRCode } from "app/services/InvoiceService";
import { pagingObj } from "app/services/PatientMethod";
import {
  getTotalUsedDeposit,
  initAdvanceMoneyTransaction,
  initFromPointTransaction,
  initPrepaidCardFromParentTransaction,
  initPrepaidCardTransaction,
  pagingPatientTransaction,
} from "app/services/PatientTransaction";
import {
  findByPromotionCode,
  pagingProgram,
  pagingProgramCrmNotLoading,
} from "app/services/PromotionCRMService";
import { pagingRewardPoint } from "app/services/RewardPoint";
import {
  applyPromotionProgram,
  pagingTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import {
  cancelTransactionOfMethod,
  cancelVoucherAndUpdateInvoice,
  cancelVoucherReason,
  createPaymentVoucherWithListMethod,
  createTemporaryVoucher,
  createVoucherAndUpdateToCrm,
  getDetailById,
  getRefundableDepositItems,
  getVoucherById,
  pageVoucherTotalCategory,
  pagingVoucherHistory,
  printApi,
  receiveAdvancePayment,
  updateTotalBillStatusInvoiceItem,
  updateVoucher,
  updateVoucherTemporary,
  createRefundDepositVoucher,
} from "app/services/VoucherService";

const DEFAULT_SEARCH_VOUCHER_FEE = {
  ...new SearchObject(),
  patientId: null,
  fromDate: new Date(new Date().getFullYear(), 0, 1),
  toDate: new Date(),
};

const DEFAULT_SELECT_METHOD_MONEY = {
  department: null,
  accountant: null,
  invoiceItems: [],
};
export default class ServiceFeeTabStore {
  searchVoucherFee = {
    ...DEFAULT_SEARCH_VOUCHER_FEE,
  };
  searchFeeCard = {
    ...new SearchObject(),
    type: TYPE_CARD[0].value,
    isAvailable: true,
    pageSize: 50,
  };
  initialValueCardFee = {
    ...DEFAULT_SELECT_METHOD_MONEY,
  };
  initialValueDepositMoneyFee = {
    ...DEFAULT_SELECT_METHOD_MONEY,
  };
  initialValueTreatmentRetainFee = {
    ...DEFAULT_SELECT_METHOD_MONEY,
  };
  initialValueLoyaltyPointFee = {
    ...DEFAULT_SELECT_METHOD_MONEY,
  };
  pageCardFee = new PageResponse();
  openConfirmDelete = null;
  openConfirmDeleteReason = null;
  openConfirmMessage = null;
  openInvoicePopup = false;
  openPopupPrint = false;
  openVoucherPopupDetail = false;
  openVoucherTempoaryPopup = false;
  openStaffRevenueUpdate = false;
  openDepositPopup = false;
  openConfirmError = null;
  openClientCardFeePopup = false;
  openDepositMoneyFeePopup = false;
  openLoyaltyPointFeePopup = false;
  openRefreshCardFee = false;
  openRefreshDepositFee = false;
  confirmRefreshDepositFee = false;

  openTreatmentRetainFeePopup = false;
  pageChangeRetain = new PageResponse();
  pageLoyaltyPoint = new PageResponse();

  dataVoucherFee = [];
  listStk = [];
  listPos = [];
  listPos_tragop = [];
  listHomecredit = [];
  listPaymentMethod = [];
  dataInvoicePopupFee = null;
  dataVoucherPopupFee = null;
  dataVoucherTemporaryPopup = null;
  editableVoucher = false;
  initialDeposit = null;
  listServiceFromFeePopupSelected = []; //lay từ form fee popup
  listSelectedSv = [];
  listSelectedCard = [];
  listSelectedRetain = [];
  listSelectedLoyalty = [];
  totalMoneySelectedRetain = 0;
  selectedFee = null;
  openPaymentVoucherPopup = false;
  openTemporaryInvoicePrintPopup = false;
  openServiceInvoicePrintPopup = false;
  initialPaymentVoucher = null;
  openRefundDepositPopup = false;
  initialRefundDeposit = null;
  dataRefundDeposit = [];


  openPopupPrintApi = false;
  listDataPrinApi = null;
  rowDataVoucher = null;
  printData = null;
  imageUrls = {};
  loadingImageIds = new Set();
  openFormCreateOrEditReasonCancel = false;
  openHistoryFeePopup = false;
  openTotalBillStatusInvoiceItemConfirm = null;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();
  pageFreePromotion = new PageResponse();
  defaultFreePromotion = null;
  promotionPrograms = []; // dùng trong form tìm ctkm
  searchFreePromotion = { ...new SearchObject() };
  openFormFreePromotion = null;
  openFormLockRetained = false;
  initialLockRetained = null;
  searchPromotionProgramVoucher = { promotionCode: null };
  listCodeSource = [];

  constructor() {
    makeAutoObservable(this);
  }

  handleOpenRefundDepositPopup = async (patient) => {
    try {
      const { data } = await getRefundableDepositItems(patient.id);
      const items = data?.items || [];
      runInAction(() => {
        this.dataRefundDeposit = items;
          this.initialRefundDeposit = {
            patient,
            totalDeposit: data?.totalDeposit || 0,
            usedDepositAmount: data?.usedDepositAmount || 0,
            depositAvailable: data?.depositAvailable || 0,
            voucherDate: new Date(),
            accountant: getCurrentStaff(),
            department: null,
            items: items.map((item) => ({
              ...item,
              refundAmount: 0,
              staffRevenues: (item.staffRevenues || []).map((sr) => ({
                ...sr,
                id: null,
              })),
              checked: false,
              voucherItemDepositId: item.id,
            })),
            listPaymentMethod: this.listPaymentMethod,
            listStk: this.listStk,
            listPos: this.listPos,
            listHomecredit: this.listHomecredit,
            listPos_tragop: this.listPos_tragop,
            note: "",

            voucherPaymentMethods: (this.listPaymentMethod || []).map((el) => {
              return {
                paymentMethodValue: el,
                totalOfMethod: 0,
                note: "",
                paymentBank:
                  el?.characteristic ===
                  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                    ? (this.listStk?.[0] || null)
                    : null,
              };
            }),
          };
        this.openRefundDepositPopup = true;
      });
    } catch (error) {
      console.error(error);
      toast.error("Lấy danh sách tiền cọc có lỗi");
    }
  };

  handleCloseRefundDepositPopup = () => {
    this.openRefundDepositPopup = false;
    this.dataRefundDeposit = [];
    this.initialRefundDeposit = null;
  };

  handleRefundDeposit = async (values, { setSubmitting, handleAfterSubmit }) => {
    try {
      const refundItems = values.items.filter((it) => it.checked && (it.refundAmount || 0) > 0);
      if (refundItems.length === 0) {
        toast.warning("Vui lòng chọn ít nhất 1 mục để hoàn tiền");
        setSubmitting(false);
        return;
      }



      const mappedRefundItems = refundItems.map((it) => {
        return {
          ...it,
          staffRevenues: (it.staffRevenues || []).map((sr) => ({
            ...sr,
            id: null,
            actualAmount: (it.refundAmount * (sr.percentRevenue || 0)) / 100,
          })),
        };
      });

      const allPaymentMethods = (values.voucherPaymentMethods || [])
        .filter((pm) => (Number(pm.totalOfMethod) || 0) > 0)
        .map((pm) => ({
          ...pm,
          totalOfMethod: Number(pm.totalOfMethod) || 0,
          bankName: pm.paymentBank?.bankName || null,
          bankAccountNumber: pm.paymentBank?.bankAccountNumber || null,
        }));

      const payload = {
        ...values,
        items: mappedRefundItems,
        voucherPaymentMethods: allPaymentMethods,
      };

      const { data } = await createRefundDepositVoucher(payload);

      if (data?.responseStatus === false) {
        runInAction(() => {
          this.openConfirmMessage = data?.responseDetail;
        });
        setSubmitting(false);
        this.getDataVoucherTotalCategory();
        return;
      }

      toast.success("Hoàn tiền cọc thành công");
      runInAction(() => {
        this.openRefundDepositPopup = false;
      });
      this.getDataVoucherTotalCategory();
      if (handleAfterSubmit) {
        handleAfterSubmit();
      }
    } catch (error) {
      console.error(error);
      toast.error("Hoàn tiền cọc có lỗi");
    } finally {
      setSubmitting(false);
    }
  };


  fetchImage = async (fileId) => {
    if (this.imageUrls[fileId] || this.loadingImageIds.has(fileId)) return;

    this.loadingImageIds.add(fileId);

    try {
      const res = await getFileById(fileId);
      const imageUrl = URL.createObjectURL(res.data);
      runInAction(() => {
        this.imageUrls[fileId] = imageUrl;
      });
    } catch (error) {
      console.error("Lỗi tải ảnh:", error);
    }
  };

  getImageUrl = (fileId) => {
    return this.imageUrls[fileId];
  };

  handleOpenPopupPrintApi = async (voucher) => {
    try {
      const { data } = await printApi(voucher.id);

      this.listDataPrinApi = data;
      this.rowDataVoucher = voucher;
      this.openPopupPrintApi = true;
    } catch (error) {
      console.error("Print API Error:", error);
      toast.error("Lấy dữ liệu Print Api có lỗi");
    }
  };

  handleClosePrintPopupApi = () => {
    this.openPopupPrintApi = false;
    this.listDataPrinApi = null;
    this.rowDataVoucher = null;
  };

  handleFeePopupPrint = (row) => {
    this.selectedFee = row;
  };

  setOpenTemporaryInvoicePrintPopup = (state) => {
    this.openTemporaryInvoicePrintPopup = state;
  };

  setOpenServiceInvoicePrintPopup = (state) => {
    this.openServiceInvoicePrintPopup = state;
  };

  formatDataPrint = (values) => {
    const allItems = [
      ...(values?.services?.items || []),
      ...(values?.products?.items || []),
      ...(values?.prepaidCards?.items || []),
      ...(values?.treatmentCards?.items || []),
    ];
    const data = allItems?.filter((item) => item?.checked);
    return data;
  };
  handleGetQrPrint = async (values, transferContent) => {
    let paymentBank = values?.voucherPaymentMethods?.find(
      (el) =>
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
    )?.paymentBank;
    let QRCode = {};
    if (paymentBank) {
      let newSearchObj = {
        amount: values?.moneyAfterDiscount,
        content: transferContent || "CK",
        acquierId: paymentBank?.propertyValue,
        consumerId: paymentBank?.property,
      };

      QRCode.qrBankCode = await invoiceGenerateQRCode(newSearchObj)
        .then(({ data }) => {
          const base64String = btoa(
            new Uint8Array(data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          return `data:image/jpeg;base64,${base64String}`;
        })
        .catch((error) => {
          toast.error("Lấy QR thất bại");
        });

      return QRCode;
    }
    return null;
  };
  setPrintData = async (values) => {
    const data = this.formatDataPrint(values);
    let QRCode = await this.handleGetQrPrint(values);
    this.printData = {
      items: data,
      QRCode,
    };
  };

  getDataDetailVoucher = async (voucher, defaultDepartment) => {
    const voucherId = voucher?.id;
    this.editableVoucher = false;
    if (!voucherId) {
      return;
    }
    return await getVoucherById(voucherId)
      .then(async ({ data }) => {
        let { voucherPaymentMethods } = data;
        let voucherPaymentMethodsFormat = await this.handleGetBankMethod(
          voucherPaymentMethods
        );
        this.dataVoucherPopupFee = {
          ...data,
          voucherPaymentMethods: voucherPaymentMethodsFormat,
        };
        this.getListProperties({
          departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
        });
        this.openVoucherPopupDetail = true;
      })
      .catch(({ error }) => {
        toast.error("Lấy chi tiết phiếu thu có lỗi");
      });
  };

  handleGetBankMethod = async (voucherPaymentMethods) => {
    console.log("lotttt");
    if (voucherPaymentMethods?.length > 0) {
      const formatItems = await Promise.all(
        (voucherPaymentMethods || []).map(async (item) => {
          if (item?.bankAccountNumber) {
            let paymentBank = await pagingExtGlobalProperty({
              keyword: item?.bankAccountNumber,
              pageIndex: 1,
              pageSize: 1,
              isActive: true,
            });
            return {
              ...item,
              paymentBank: paymentBank?.data?.content?.[0],
            };
          } else {
            return item;
          }
        })
      );
      return formatItems;
    }
    return [];
  };

  getDataTemporaryVoucher = async (voucher) => {
    const voucherId = voucher?.id;
    this.editableVoucher = false;

    if (!voucherId) {
      return;
    }
    return await getVoucherById(voucherId)
      .then(async ({ data }) => {
        let { voucherPaymentMethods } = data;
        let voucherPaymentMethodsFormat = await this.handleGetBankMethod(
          voucherPaymentMethods
        );
        this.dataVoucherTemporaryPopup = {
          ...data,
          voucherPaymentMethods: voucherPaymentMethodsFormat,
        };
        this.openVoucherTempoaryPopup = true;
      })
      .catch(({ error }) => {
        toast.error("Lấy chi tiết phiếu tạm có lỗi");
      });
  };

  getDataVoucherTotalCategory = async () => {
    let { departmentId, ...ortherData } = this.searchVoucherFee;

    // Không call API nếu không có cơ sở (bắt buộc) VÀ không có patientId
    // Nếu có patientId (xem thông tin khách hàng) thì không cần bắt buộc cơ sở
    if (!departmentId && !this.searchVoucherFee.patientId) {
      this.dataVoucherFee = [];
      return;
    }

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await pageVoucherTotalCategory({ ...ortherData })
      .then(({ data }) => {
        this.dataVoucherFee = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hóa đơn có lỗi");
      });
  };

  handleChangeFormSearch = (search) => {
    this.searchVoucherFee = { ...this.searchVoucherFee, ...search };
    this.getDataVoucherTotalCategory();
  };
  setListSelectedSv = (list) => {
    this.listSelectedSv = list;
  };
  setListSelectedCard = (list) => {
    this.listSelectedCard = list;
  };
  setListSelectedRetain = (list) => {
    this.listSelectedRetain = list;
  };

  setListSelectetedLoyalty = (list) => {
    this.listSelectedLoyalty = list;
  };

  handleCalculateRemaining = (el) => {
    let beforeTax;
    let tax;
    let aftefTax;
    if (el?.priceWithTax) {
      aftefTax = el?.currentFee * el?.quantity - el?.discount;
      tax =
        (aftefTax / (100 + +el?.surchargePercent || 0)) *
        (+el?.surchargePercent || 0);
      beforeTax = (aftefTax / (100 + +el?.surchargePercent || 0)) * 100;
    } else {
      beforeTax = el?.currentFee * el?.quantity - el?.discount;

      tax = (beforeTax * (el?.surchargePercent || 0)) / 100;

      aftefTax = beforeTax + tax;
    }

    let remaining =
      aftefTax -
      (el?.currentAllocateDiscount || 0) -
      el?.subTotalBillPatientPaid; // con lai
    return remaining;
  };

  handleCreateVoucherAndUpdateToCrm = async (
    obj,
    { setSubmitting, handleAfterSubmit }
  ) => {
    let api = createVoucherAndUpdateToCrm; //hàm lưu thanh toán
    let { prepaidCards, products, services, treatmentCards, patient } = obj;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    if (invoiceItems?.length === 0) {
      toast.warning("Vui lòng chọn dịch vụ để thanh toán");
      setSubmitting(false);
      return;
    }
    // if (patient?.patientAvatarId?.[0]) {
    //   patient.patientAvatarId =
    //     patient?.patientAvatarId?.[0]?.fileDescription?.id;
    // }
    let formatInvoiceItems = invoiceItems?.map((el) => {
      let { staffRevenues, currentPaymentAmount, currentAllocateDiscount } = el;
      let totalDetail =
        (+currentPaymentAmount || 0) - (+currentAllocateDiscount || 0); // tổng tiền thu

      if (staffRevenues?.length > 0) {
        staffRevenues = staffRevenues?.map((el) => {
          return {
            ...el,
            actualAmount: el?.notDefaultSubmit
              ? el?.actualAmount
              : (totalDetail * el?.percentRevenue) / 100,
          };
        });
      }

      return {
        ...el,
        staffRevenues,
        promotionProgramId: obj?.promotionProgramId,
        promotionProgramCode: obj?.promotionProgramCode,
      };
    });

    if (obj?.isCreateBill) {
      api = createTemporaryVoucher; //hàm tạo bill tạm ứng
    }
    return await api({ ...obj, patient, invoiceItems: formatInvoiceItems })
      .then(async ({ data }) => {
        const urlParams = new URLSearchParams(window.location.search);
        const patientId = urlParams.get("patientId");
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          this.getDataVoucherTotalCategory({ patientId });
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        }
        if (obj?.isCreateBill) {
          // xử lí hàm tạo bill tạm
          toast.success("Tạo bill tạm thành công!");
          const dataPrint = this.formatDataPrint(obj);
          let QRCode = await this.handleGetQrPrint(obj, data?.transferContent);

          this.printData = {
            items: dataPrint,
            listInvoiceItems: data,
            QRCode,
          };
          this.setOpenTemporaryInvoicePrintPopup(true);
          // this.openInvoicePopup = false;
        } else {
          this.openInvoicePopup = false;
          toast.success("Thanh toán thành công!");
          if (data?.id) {
            this.handleOpenPopupPrintApi(data);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Thanh toán có lỗi");
      });
  };

  handleUpdateVoucher = async (obj, { setSubmitting, handleAfterSubmit }) => {
    return updateVoucher({ ...obj })
      .then(async ({ data }) => {
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          setSubmitting(false);
          return;
        } else {
          toast.success("Cập nhật thành công!");
          this.openVoucherPopupDetail = false;
          this.getDataVoucherTotalCategory();

          // thêm để gọi hàm overview
          if (handleAfterSubmit) {
            setTimeout(() => {
              handleAfterSubmit();
            }, 500);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleUpdateTemporaryVoucher = async (obj, { setSubmitting }) => {
    return updateVoucherTemporary({ ...obj })
      .then(async ({ data }) => {
        console.log("dataa", data);
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          setSubmitting(false);
          return;
        } else {
          toast.success("Cập nhật thành công!");
          this.openVoucherTempoaryPopup = false;
          this.getDataVoucherTotalCategory();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  setOpenConfirmError = (state) => {
    this.openConfirmError = state;
  };

  setInitialValuePopupFee = (data) => {
    let { prepaidCards, products, services, treatmentCards } = data;
    let totalAmount = 0;
    if (data.prepaidCards) {
      data.prepaidCards.items = prepaidCards?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);

        totalAmount += SELECT_ALL_ITEM_FEE ? remaining : 0;
        return {
          ...el,
          checked: SELECT_ALL_ITEM_FEE ? true : false,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.products) {
      data.products.items = products?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);

        totalAmount += SELECT_ALL_ITEM_FEE ? remaining : 0;

        return {
          ...el,
          checked: SELECT_ALL_ITEM_FEE ? true : false,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.services) {
      data.services.items = services?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);

        totalAmount += SELECT_ALL_ITEM_FEE ? remaining : 0;

        return {
          ...el,
          checked: SELECT_ALL_ITEM_FEE ? true : false,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.treatmentCards) {
      data.treatmentCards.items = treatmentCards?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);

        totalAmount += SELECT_ALL_ITEM_FEE ? remaining : 0;

        return {
          ...el,
          checked: SELECT_ALL_ITEM_FEE ? true : false,
          currentPaymentAmount: remaining,
        };
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank
    if (
      !data?.voucherPaymentMethods ||
      data?.voucherPaymentMethods?.length === 0
    ) {
      voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
        return {
          paymentMethodValue: el,
          totalOfMethod:
            el?.characteristic ===
            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
              ? totalAmount
              : 0,

          note: "",
          paymentBank:
            el?.characteristic ===
            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
              ? this.listStk?.[0]
              : null,
        };
      });
    }

    return {
      ...data,
      voucherPaymentMethods,
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      paymentMethodSelect: SELECT_ALL_ITEM_FEE,
      totalAmount,
      percentDiscount: 0,
      discount: 0,
      moneyAfterDiscount: totalAmount,
    };
  };

  getDataInvoicePopupFee = async (obj) => {
    return await getInvoiceItemByType({ ...obj, incompletePaymentItems: true })
      .then(async ({ data }) => {
        let formatData = this.setInitialValuePopupFee({
          ...data,
          patient: obj?.patient,
        });
        this.dataInvoicePopupFee = formatData;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      });
  };

  handleReceiveAdvancePayment = (values, { setSubmitting }) => {
    return receiveAdvancePayment(values)
      .then(async ({ data }) => {
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          setSubmitting(false);
          return data;
        } else {
          this.openDepositPopup = false;
          toast.success("Lưu tiền cọc thành công");
          this.getDataVoucherTotalCategory();
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  setOpenStaffRevenueUpdate = (state) => {
    this.openStaffRevenueUpdate = state;
  };

  createPaymentVoucherWithListMethod = async (values, { setSubmitting }) => {
    let { patient, ...ortherData } = values;
    if (patient?.patientAvatarId?.[0]) {
      patient.patientAvatarId =
        patient?.patientAvatarId?.[0]?.fileDescription?.id;
    }
    return await createPaymentVoucherWithListMethod({ ...ortherData, patient })
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          console.log("setSubmitting", setSubmitting);
          if (setSubmitting) {
            setSubmitting(false);
          }
          return data;
        } else {
          toast.success("Tạo phiếu chi thành công");
          this.openPaymentVoucherPopup = false;
          if (!values?.notPaging) {
            this.getDataVoucherTotalCategory();
          }
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Tạo phiếu chi có lỗi");
      });
  };

  initDataInvoiceUpdatePopup = async (obj, defaultDepartment) => {
    return await getDetailById(obj?.id)
      .then(async ({ data }) => {
        // hàm khởi tạo lấy dữ liệu stk,pos
        await this.getListProperties({
          departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
        });
        let { voucherPaymentMethods, voucherInvoiceType } = data;
        let isAdvance =
          VOUCHER_INVOICE_TYPE_VALUE.Advance === voucherInvoiceType;
        if (isAdvance) {
          voucherPaymentMethods = voucherPaymentMethods.filter(
            (el) =>
              el?.paymentMethodValue?.code ===
                PAYMENT_METHOD_CHARACTERISTIC_CASH_CODE ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_POS
          );
        }

        if (voucherPaymentMethods?.length > 0) {
          // let voucherPaymentMethodsFormat = await this.handleGetBankMethod(
          //   voucherPaymentMethods
          // );

          let voucherPaymentMethodsFormat = voucherPaymentMethods?.map((el) => {
            if (
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_POS ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
            ) {
              if (el?.bankAccountNumber && el?.bankName) {
                return {
                  ...el,
                  paymentBank: {
                    property: el?.bankAccountNumber,
                    propertyName: el?.bankName,
                  },
                };
              } else {
                return el;
              }
            }
            return el;
          });
          // console.log(
          //   "voucherPaymentMethodsFormat",
          //   voucherPaymentMethodsFormat
          // );

          this.dataVoucherPopupFee = {
            ...data,
            voucherPaymentMethods: voucherPaymentMethodsFormat,
          };
        } else {
          this.dataVoucherPopupFee = data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      });
  };

  handleInitPaymentVoucherPopup = (
    patient,
    listPaymentMethod,
    customerSourceWalkIn,
    orther
  ) => {
    let staffRevenues = [];
    if (patient?.currentConsultant) {
      staffRevenues.push({
        position: patient?.currentConsultant?.position,
        staff: patient?.currentConsultant,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        percentRevenue: 100,
        actualAmount: 0,
      });
    }
    if (patient?.currentTelesale) {
      staffRevenues.push({
        position: patient?.currentTelesale?.position,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        staff: patient?.currentTelesale,
        percentRevenue: 100,
        actualAmount: 0,
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank
    let formatListPaymentMethod =
      listPaymentMethod?.length > 0
        ? listPaymentMethod
        : this.listPaymentMethod;

    voucherPaymentMethods = // có thể lấy từ liệu trình
      formatListPaymentMethod?.map((el) => {
        return {
          paymentMethodValue: el,
          totalOfMethod: 0,
          note: "",
          paymentBank:
            el?.characteristic ===
            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
              ? this.listStk?.[0]
              : null,
        };
      });
    this.initialPaymentVoucher = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      patient,
      voucherPaymentMethods,
      totalAmount: 0,
      ...orther,
    };
  };

  handleOpenPaymentVoucherPopup = (
    patient,
    listPaymentMethod,
    customerSourceWalkIn,
    ortherData
  ) => {
    this.handleInitPaymentVoucherPopup(
      patient,
      listPaymentMethod,
      customerSourceWalkIn,
      ortherData
    );
    this.openPaymentVoucherPopup = true;
  };

  handleClosePaymentVoucherPopup = () => {
    this.openPaymentVoucherPopup = false;
    this.initialPaymentVoucher = null;
  };

  setDataVoucherPopupFee = (obj) => {
    this.dataVoucherPopupFee = obj;
  };

  handleOpenServiceFeePopup = (voucher) => {
    let { patient } = voucher;
    this.openInvoicePopup = true;
    this.getDataInvoicePopupFee({ patient, patientId: patient?.id });
  };

  handleOpenServiceUpdate = (voucher, defaultDepartment) => {
    this.openVoucherPopupDetail = true;
    this.editableVoucher = true;
    if (voucher?.id) {
      this.initDataInvoiceUpdatePopup(voucher, defaultDepartment);
    }
  };
  handleCloseServiceFeePopup = () => {
    this.openInvoicePopup = false;
    this.openVoucherPopupDetail = false;
    this.dataVoucherPopupFee = null;
  };

  handleCloseVoucherTemporaryPopup = () => {
    // this.openInvoicePopup = false;
    this.openVoucherTempoaryPopup = false;
  };
  handleClosePrintPopup = () => {
    this.openPopupPrint = false;
  };
  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  getListPaymentMethod = async () => {
    return await pagingObj({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      isUse: true,
    })
      .then(({ data }) => {
        this.listPaymentMethod = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  getListProperties = async (obj) => {
    return await pagingExtGlobalProperty({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      isActive: true,
      ...obj,
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          const listStk = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_BANK
          );
          this.listStk = listStk;
          const listPos = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_LIST
          );
          this.listPos = listPos;

          const listPos_tragop = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP
          );
          this.listPos_tragop = listPos_tragop;

          const listHomecredit = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE
          );
          this.listHomecredit = listHomecredit;

          return {
            listStk,
            listPos,
            listPos_tragop,
            listHomecredit,
          };
        } else {
          return {
            listStk: [],
            listPos: [],
            listPos_tragop: [],
            listHomecredit: [],
          };
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  handleOpenPopupPrint = (state) => {
    this.openPopupPrint = state;
  };

  handleInitDeposit = (patient, customerSourceWalkIn) => {
    let staffRevenues = [];
    if (patient?.currentConsultant) {
      staffRevenues.push({
        position: patient?.currentConsultant?.position,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        percentRevenue: 100,
        actualAmount: 0,
      });
    }
    if (patient?.currentTelesale || patient?.currentTelesale2) {
      const telesale = patient?.currentTelesale || patient?.currentTelesale2;
      staffRevenues.push({
        position: telesale?.position,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        staff: telesale,
        percentRevenue: 100,
        actualAmount: 0,
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank

    voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
      let paymentBank =
        el?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
          ? {
              paymentBank: this.listStk?.[0],
              bankName: this.listStk?.[0]?.propertyName,
              bankAccountNumber: this.listStk?.[0]?.property,
            }
          : [];
      return {
        paymentMethodValue: el,
        totalOfMethod: 0,
        note: "",
        ...paymentBank,
      };
    });
    this.initialDeposit = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      patient,
      voucherPaymentMethods,
      // voucherItemRevenueType: LAVoucherItemRevenueType.NEW_REVENUE.value,
      totalAmount: 0,
    };
  };
  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleOpenConfirmDeleteReason = (id) => {
    this.openConfirmDeleteReason = id;
  };

  handleDeleteVoucherWithReason = async (cancelReason) => {
    return cancelVoucherReason({
      id: this.openConfirmDeleteReason,
      cancelReason,
    })
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          this.setOpenConfirmError(data);
          return data;
        } else {
          this.openConfirmDeleteReason = null;
          toast.success("Xóa hóa đơn thành công");
          this.getDataVoucherTotalCategory();
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa hóa đơn có lỗi");
      });
  };

  handleDeleteVoucher = async () => {
    return await cancelVoucherAndUpdateInvoice(this.openConfirmDelete)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          this.setOpenConfirmError(data);
          return data;
        } else {
          this.openConfirmDelete = null;
          toast.success("Xóa hóa đơn thành công");
          this.getDataVoucherTotalCategory();
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa  hóa đơn có lỗi");
      });
  };
  pagingFeeCard = async (patientId) => {
    return await pagingTreatmentPlanCard({ ...this.searchFeeCard, patientId })
      .then(({ data }) => {
        this.pageCardFee = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleOpenDepositPopup = (
    patient,
    customerSourceWalkIn,
    defaultDepartment
  ) => {
    this.handleInitDeposit(patient, customerSourceWalkIn);
    this.getListProperties({
      departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
    });
    const searchCodeSource = {
      level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
      startDate: new Date(),
      patientId: patient?.id,
      departmentId: defaultDepartment?.id,
    };
    this.handleGetListCodeSource(searchCodeSource);

    this.openDepositPopup = true;
  };

  handleCloseDepositPopup = () => {
    this.openDepositPopup = false;
  };

  handleOpenClientCardFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    await this.pagingFeeCard(patientId);
    this.listServiceFromFeePopupSelected = invoiceItems;
    let cardUsedValue =
      this.pageCardFee?.content?.length > 0 &&
      this.pageCardFee?.content?.reduce((acc, curr) => {
        return acc + curr?.totalValue * curr?.quantity - curr?.totalUsed;
      }, 0);
    this.listSelectedCard = this.pageCardFee?.content;
    this.listSelectedSv = invoiceItems;
    this.initialValueCardFee = {
      department,
      accountant,
      cardUsedValue,
      moneyAfterDiscount: values?.moneyAfterDiscount,
      dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
    };
    this.openClientCardFeePopup = true;
  };

  // hàm xử lí cập nhật thẻ khi update
  handleOpenClientCardUpdateFeePopup = async (values) => {
    let { items, patientId, department, accountant } = values;
    let invoiceItems = items?.map((el) => ({
      ...el?.invoiceItem,
      currentPaymentAmount: el?.invoiceItem?.subAmountActuallyPaid,
    }));
    await this.pagingFeeCard(patientId);
    this.listServiceFromFeePopupSelected = invoiceItems;
    let cardUsedValue =
      this.pageCardFee?.content?.length > 0 &&
      this.pageCardFee?.content?.reduce((acc, curr) => {
        return acc + curr?.totalValue * curr?.quantity - curr?.totalUsed;
      }, 0);
    this.listSelectedCard = this.pageCardFee?.content;
    this.listSelectedSv = invoiceItems;
    this.initialValueCardFee = {
      department,
      accountant,
      cardUsedValue,
      moneyAfterDiscount: values?.moneyAfterDicount,
      dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
    };
    this.openClientCardFeePopup = true;
  };

  handleOpenDepositMoneyFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    try {
      let { data } = await getTotalUsedDeposit(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueDepositMoneyFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        totalAdvanceAmount: data,
        patientId,
      };
      this.openDepositMoneyFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleInitCardItemsAndServiceItems = async (values) => {
    return await initPrepaidCardTransaction({
      cards: this.listSelectedCard,
      invoiceItems: this.listSelectedSv,
      accountant: values?.accountant,
      department: values?.department,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu phân bổ thẻ có lỗi");
      });
  };

  // hàm này dùng ở chọn thẻ popup thanh toán
  handleSubmitTransactionCard = (values) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    let { cardUsedValue } = values;
    const totalOfMethodCard =
      values?.transItems?.length > 0
        ? values?.transItems?.reduce((acc, curr) => {
            return acc + roundVnd(curr?.amount);
          }, 0)
        : 0;
    const totalOfMethodDeposit = //tìmtiền cọc
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      ) {
        // nếu là thẻ thì gán
        return {
          ...el,
          totalOfMethod: totalOfMethodCard,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        // nếu là thu nợ thì giữ nguyên
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        // nếu là tiền ck thì trừ 2 tk kia
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodCard -
            totalOfMethodDeposit -
            totalOfMethodLoyaltyPoint -
            totalOfMethodTreatmentRetain,
        };
      }
      return el;
    });
    this.openClientCardFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
      totalRemaningCard: cardUsedValue - totalOfMethodCard,
    };
  };

  // hàm này dùng ở chọn thẻ popup update
  handleSubmitTransactionCardPopupUpdate = (values) => {
    //logic lặp tìm tiền thẻ ,tiền cọc ,sau đó thì lấy tiền tổng - đi để lấy tiền ck
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;
    const totalOfMethodCard =
      values?.transItems?.length > 0
        ? values?.transItems?.reduce((acc, curr) => {
            return acc + roundVnd(curr?.amount);
          }, 0)
        : 0;

    const totalOfMethodDeposit = //tìmtiền cọc
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodCard,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodCard -
            totalOfMethodDeposit -
            totalOfMethodTreatmentRetain -
            totalOfMethodLoyaltyPoint,
        };
      }
      return el;
    });
    this.openClientCardFeePopup = false;
    this.dataVoucherPopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  handleInitAdvanceMoneyTransaction = async (values) => {
    return await initAdvanceMoneyTransaction({
      invoiceItems: this.listSelectedSv,
      accountant: values?.accountant,
      department: values?.department,
      totalAdvanceAmount: values?.totalAdvanceAmount,
      patientId: values?.patientId,
      distributionMode: values?.distributionMode,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu phân bổ tiền cọc có lỗi");
      });
  };
  // dùng khi chọn dùng số dư liệu trình popup thanh toán
  handleOpenTreatmentRetainFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    try {
      await this.pagingTreatmentPatientTransaction(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueTreatmentRetainFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        patientId,
      };
      this.openTreatmentRetainFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenTreatmentRetainFeePopupUpdate = async (values) => {
    //console.log(values, "values");
    let { patientId, department, accountant, items } = values;
    let invoiceItems = [];
    for (const item of items) {
      const newItem = {
        ...item?.invoiceItem,
        //item?.moneyAfterDiscount || 0,
        currentPaymentAmount: item?.amount,
      };
      //delete newItem.content; // xoá content cũ nếu không cần

      invoiceItems.push(newItem);
    }
    try {
      await this.pagingTreatmentPatientTransaction(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueTreatmentRetainFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        patientId,
      };
      this.openTreatmentRetainFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  pagingRewardPointPatient = async (patientId) => {
    return await pagingRewardPoint({
      patientId,
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      getAmountVaild: true,
      isStillValid: true,
    })
      .then(({ data }) => {
        this.pageLoyaltyPoint = data;
        this.setListSelectetedLoyalty(data?.content);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điểm khách hàng có lỗi");
      });
  };

  pagingTreatmentPatientTransaction = async (patientId) => {
    return await pagingPatientTransaction({
      patientId,
      transactionCategory: VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD,
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      isStillValid: true,
    })
      .then(({ data }) => {
        this.pageChangeRetain = data;

        this.setListSelectedRetain(data?.content);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chuyển đổi số dư có lỗi");
      });
  };

  handleInitTreatmentRetainTransaction = async (values) => {
    return await initPrepaidCardFromParentTransaction({
      invoiceItems: this.listSelectedSv,
      parentTransItems: this.listSelectedRetain,
      accountant: values?.accountant,
      department: values?.department,
      patientId: values?.patientId,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chuyển đổi số dư có lỗi");
      });
  };

  handleInitTreatmentRetainTransactionUpdate = async (values) => {
    console.log(values);
    return await initPrepaidCardFromParentTransaction({
      invoiceItems: this.listSelectedSv,
      parentTransItems: this.listSelectedRetain,
      accountant: values?.accountant,
      department: values?.department,
      patientId: values?.patientId,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chuyển đổi số dư có lỗi");
      });
  };

  //dùng ở popupchọn tiền khấu trừ ở màn thanh toán
  handleSubmitTransactionTreatmentRetain = (values, { setSubmitting }) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    let total =
      this.listSelectedRetain?.length > 0 &&
      this.listSelectedRetain?.reduce((acc, curr) => {
        return acc + (curr?.amount - curr?.usedAmount || 0);
      }, 0);

    const totalOfMethodTreatmentRetain =
      values?.transItems?.length > 0 > 0
        ? values?.transItems?.reduce((acc, curr) => {
            return acc + roundVnd(curr?.amount);
          }, 0)
        : 0;

    // xử lí validate tổng tiền ko vượt quá tiền sử dụng
    if (total < totalOfMethodTreatmentRetain) {
      toast.warning("Số tiền phân bổ không được vượt quá tổng tiền sử dụng");
      if (setSubmitting) setSubmitting(false);
      return;
    }

    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodDeposit =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.code ===
        PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodTreatmentRetain,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodTreatmentRetain -
            totalOfMethodCard -
            totalOfMethodDeposit -
            totalOfMethodLoyaltyPoint,
        };
      }
      return el;
    });
    this.openTreatmentRetainFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
      // totalRemaningTreatmentRetain:
      //   totalAdvanceAmount - totalOfMethodTreatmentRetain,
    };
  };

  handleSubmitTransactionTreatmentRetainUpdate = (
    values,
    { setSubmitting }
  ) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    // Tổng user nhập vào popup treatment-retain
    const totalOfMethodTreatmentRetain =
      values?.transItems?.length > 0
        ? roundVnd(values.transItems.reduce((acc, curr) => acc + roundVnd(curr?.amount), 0))
        : 0;

    // Tổng tiền khả dụng (số dư có thể dùng)
    const totalAvailable =
      this.listSelectedRetain?.length > 0
        ? this.listSelectedRetain.reduce((acc, curr) => {
            return acc + (curr?.amount - (curr?.usedAmount || 0));
          }, 0)
        : 0;

    // Validate tổng tiền nhập ko vượt quá số tiền sử dụng
    if (totalOfMethodTreatmentRetain > totalAvailable) {
      toast.warning("Số tiền phân bổ không được vượt quá tổng tiền sử dụng");
      if (setSubmitting) setSubmitting(false);
      return;
    }

    // Lấy lại tổng tiền hiện có các hình thức khác
    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodDeposit =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    // CẬP NHẬT voucherPaymentMethods
    voucherPaymentMethods = voucherPaymentMethods.map((el) => {
      const method = el?.paymentMethodValue;

      // CASE 1: Treatment-Retain
      if (
        method?.code === PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodTreatmentRetain,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      }

      // ⭐⭐ CASE 2: PREPAID-CARD UPDATE — thêm theo yêu cầu của bạn
      if (
        method?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      ) {
        return {
          ...el,
          isCal: true,
          totalOfMethod: totalOfMethodCard, // giữ nguyên số tiền đang có
        };
      }

      // CASE 3: DEPOSIT
      if (
        method?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      ) {
        return {
          ...el,
          isCal: true,
          totalOfMethod: totalOfMethodDeposit,
        };
      }

      // CASE 4: LOYALTY POINT
      if (method?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY) {
        return {
          ...el,
          isCal: true,
          totalOfMethod: totalOfMethodLoyaltyPoint,
        };
      }

      // CASE 5: BANK TRANSFER / POS (tính toán lại phần còn thiếu)
      if (
        method?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodTreatmentRetain -
            totalOfMethodDeposit -
            totalOfMethodCard -
            totalOfMethodLoyaltyPoint,
        };
      }

      return el;
    });

    // Cập nhật cuối
    this.openTreatmentRetainFeePopup = false;
    this.dataVoucherPopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  //dùng ở popupchọn ghi nợ ở màn thanh toán
  handleSubmitTransactionDepositMoney = (values) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    let { totalAdvanceAmount } = values;
    const totalOfMethodDeposit = roundVnd(
      values?.transItems?.length > 0
        ? values.transItems.reduce(
            (acc, curr) => acc + roundVnd(curr?.amount),
            0
          )
        : 0
    );

    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodDeposit,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodDeposit -
            totalOfMethodCard -
            totalOfMethodTreatmentRetain -
            totalOfMethodLoyaltyPoint,
        };
      }
      return el;
    });
    console.log("voucherPaymentMethods", voucherPaymentMethods);
    this.openDepositMoneyFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
      totalRemaningDeposit: totalAdvanceAmount - totalOfMethodDeposit,
    };
  };

  // dùng để mở popup
  handleOpenDepositMoneyFeePopupUpdate = async (values) => {
    let { items, patientId, department, accountant } = values;
    let invoiceItems =
      items?.length > 0 &&
      items?.map((el) => ({
        ...el?.invoiceItem,
        currentPaymentAmount: el?.amount,
      }));
    try {
      let { data } = await getTotalUsedDeposit(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueDepositMoneyFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        totalAdvanceAmount: data,
        patientId,
      };
      this.openDepositMoneyFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  //dùng ở popupchọn ghi nợ ở màn chỉnh sửa thanh toán
  handleSubmitTransactionDepositMoneyPopupUpdate = (values) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    const totalOfMethodDeposit = roundVnd(
      values?.transItems?.length > 0
        ? values.transItems.reduce(
            (acc, curr) => acc + roundVnd(curr?.amount),
            0
          )
        : 0
    );

    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    const totalOfMethodLoyaltyPoint =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodDeposit,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodDeposit -
            totalOfMethodCard -
            totalOfMethodTreatmentRetain -
            totalOfMethodLoyaltyPoint,
        };
      }
      return el;
    });
    this.openDepositMoneyFeePopup = false;
    this.dataVoucherPopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  // dùng để mở popup dùng điểm
  handleOpenLoyaltyPointPopupUpdate = async (values) => {
    let { items, patientId, department, accountant } = values;
    let invoiceItems =
      items?.length > 0 &&
      items?.map((el) => ({
        ...el?.invoiceItem,
        currentPaymentAmount: el?.amount,
      }));
    try {
      await this.pagingRewardPointPatient(patientId);

      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueLoyaltyPointFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        patientId,
      };
      this.openLoyaltyPointFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  //dùng ở popupchọn ghi nợ ở màn chỉnh sửa thanh toán
  handleSubmitLoyaltyPointUpdate = (values) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    const totalOfMethodLoyaltyPoint =
      values?.transItems?.length > 0
        ? values?.transItems?.reduce((acc, curr) => {
            return acc + roundVnd(curr?.amount);
          }, 0)
        : 0;

    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    const totalOfMethodDeposit =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodLoyaltyPoint,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      ) {
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodDeposit -
            totalOfMethodCard -
            totalOfMethodTreatmentRetain -
            totalOfMethodLoyaltyPoint,
        };
      }
      return el;
    });
    this.openLoyaltyPointFeePopup = false;
    this.dataVoucherPopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  handleInitLoyaltyPoint = async (values) => {
    return await initFromPointTransaction({
      invoiceItems: this.listSelectedSv,
      pointTransactions: this.listSelectedLoyalty,
      accountant: values?.accountant,
      department: values?.department,
      patientId: values?.patientId,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điểm người dùng có lỗi");
      });
  };

  //dùng ở popup chọn dùng điểm ở màn thanh toán
  handleSubmitLoyaltyPoint = (values, { setSubmitting }) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;

    let total =
      this.listSelectedLoyalty?.length > 0 &&
      this.listSelectedLoyalty?.reduce((acc, curr) => {
        return acc + curr?.convertedAmount;
      }, 0);

    const totalOfMethodLoyaltyPoint =
      values?.transItems?.length > 0
        ? values?.transItems?.reduce((acc, curr) => {
            return acc + roundVnd(curr?.amount);
          }, 0)
        : 0;

    // xử lí validate tổng tiền ko vượt quá tiền sử dụng
    if (total < totalOfMethodLoyaltyPoint) {
      toast.warning("Số tiền phân bổ không được vượt quá tổng tiền sử dụng");
      if (setSubmitting) setSubmitting(false);
      return;
    }

    // totalOfMethodTreatmentRetain
    const totalOfMethodCard =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
      )?.totalOfMethod || 0;

    const totalOfMethodDeposit =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
      )?.totalOfMethod || 0;

    const totalOfMethodTreatmentRetain =
      voucherPaymentMethods?.find(
        (el) =>
          el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      )?.totalOfMethod || 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.code === PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodLoyaltyPoint,
          detailTransaction: { transItems: values?.transItems },
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
        el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
        el?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
      ) {
        return {
          ...el,
          isCal: true,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount -
            totalOfMethodTreatmentRetain -
            totalOfMethodCard -
            totalOfMethodDeposit,
        };
      }
      return el;
    });
    this.openLoyaltyPointFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
      // totalRemaningTreatmentRetain:
      //   totalAdvanceAmount - totalOfMethodTreatmentRetain,
    };
  };

  // dùng khi chọn dùng đổi điểm popup thanh toán
  handleOpenLoyaltyFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    try {
      await this.pagingRewardPointPatient(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueLoyaltyPointFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        patientId,
      };
      this.openLoyaltyPointFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseClientCardFeePopup = () => {
    this.openClientCardFeePopup = false;
    this.listSelectedSv = [];
    this.listSelectedCard = [];
  };

  handleCloseDepositMoneyFeePopup = () => {
    this.openDepositMoneyFeePopup = false;
    this.listSelectedSv = [];
    this.listSelectedCard = [];
  };

  handleCloseLoyaltyPointFeePopup = () => {
    this.openLoyaltyPointFeePopup = false;
    this.listSelectedSv = [];
    this.pageLoyaltyPoint = new PageResponse();
  };

  handleCloseTreatmentRetainFeePopup = () => {
    this.openTreatmentRetainFeePopup = false;
    // this.listSelectedSv = [];
    // this.listSelectedCard = [];
    this.pageChangeRetain = new PageResponse();
  };
  handleOpenRefreshCardFee = (obj) => {
    this.openRefreshCardFee = obj;
  };

  handleOpenRefreshDepositFee = (obj) => {
    this.openRefreshDepositFee = obj;
  };

  handleCloseRefreshCardFee = () => {
    this.openRefreshCardFee = null;
  };

  handleCloseRefreshDepositFee = () => {
    this.openRefreshDepositFee = null;
  };

  handleCloseConfirmRefreshCardFee = () => {
    this.openRefreshCardFee = null;
  };

  handleConfirmRefreshCardFee = async (values) => {
    let { voucherPaymentMethods, ...ortherData } = values;
    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          bankAccountNumber: el?.bankAccountNumber
            ? el?.bankAccountNumber
            : this.listStk?.[0]?.property,
          bankName: el?.bankName
            ? el?.bankName
            : this.listStk?.[0]?.propertyName,
        };
      }
      return el;
    });
    try {
      const { data } = await cancelTransactionOfMethod(this.openRefreshCardFee);
      if (data > 0) {
        await updateVoucher({ ...values, voucherPaymentMethods });
        toast.success("Cập nhật thành công");
      }
      this.openRefreshCardFee = null;
    } catch (error) {
      toast.error(error);
    }
  };

  // xử lí chương tình khuyến mãi START

  pagingFreePromotion = async () => {
    let listFreeCode = getPromotionCodes();
    return await pagingProgramCrmNotLoading({
      ...this.searchFreePromotion,
      codes: listFreeCode,
    })
      .then(({ data }) => {
        this.pageFreePromotion = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chương trình khuyến mãi có lỗi");
      });
  };

  getDefaultFreePromotion = async () => {
    let listFreeCode = getPromotionCodes();
    return await pagingProgramCrmNotLoading({
      ...this.searchFreePromotion,
      codes: listFreeCode,
      productCode: PROMOTION_DEFAULT_CODE,
    })
      .then(({ data }) => {
        this.defaultFreePromotion = data?.content[0];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chương trình khuyến mãi có lỗi");
      });
  };

  handleChangeFormSearchFreePromotion = (searchFreePromotion) => {
    this.searchFreePromotion = {
      ...this.searchFreePromotion,
      ...searchFreePromotion,
    };
    this.pagingFreePromotion();
  };

  handleCloseHistoryFeePopup = async () => {
    this.openHistoryFeePopup = false;
    this.searchDataHistory = null;
  };

  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    return await pagingVoucherHistory({ ...this.searchDataHistory })
      .then(({ data }) => {
        this.pageDataHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử thanh toán có lỗi");
      });
  };

  handleOpenHistoryFeePopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenTotalBillStatusInvoiceItemConfirm = async (obj) => {
    this.openTotalBillStatusInvoiceItemConfirm = obj;
  };

  handleCloseTotalBillStatusInvoiceItemConfirm = async (obj) => {
    this.openTotalBillStatusInvoiceItemConfirm = null;
  };

  updateTotalBillStatusInvoiceItem = async () => {
    return await updateTotalBillStatusInvoiceItem(
      this.openTotalBillStatusInvoiceItemConfirm
    )
      .then(({ data }) => {
        toast.success(
          "Cập nhật trạng thái thanh toán và tính lại số tiền thành công"
        );
        this.openTotalBillStatusInvoiceItemConfirm = null;
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Lỗi khi cập nhật trạng thái thanh toán và tính lại số tiền"
        );
      });
  };

  applyPromotion = async (obj) => {
    let { paServiceRegister, drugs, ...ortdherData } = obj;
    let paServiceRegisterFormat =
      paServiceRegister?.length > 0
        ? paServiceRegister?.map((el) => ({
            ...el,
            amountActuallyPaid: el?.amount,
          }))
        : [];
    let drugsFormat =
      drugs?.length > 0
        ? drugs?.map((el) => ({
            ...el,
            amountActuallyPaid: el?.amount,
          }))
        : [];
    try {
      const { data } = await applyPromotionProgram({
        ...ortdherData,
        paServiceRegister: paServiceRegisterFormat,
        drugs: drugsFormat,
      });

      if (data?.responseStatus === false) {
        toast.error(data?.responseDetail || "Áp dụng khuyến mãi thất bại");
      } else {
        return data;
      }
    } catch (error) {
      console.error("❌ applyPromotion error:", error);
      toast.error("Không thể áp dụng chương trình khuyến mãi");
    }
  };

  handleChangeFormSearchPromotionProgram = (searchObj) => {
    this.searchPromotionProgramVoucher = {
      ...this.searchPromotionProgramVoucher,
      ...searchObj,
    };
    this.getPromotionPrograms();
  };

  getPromotionPrograms = async () => {
    try {
      let { drugs, paServiceRegister, promotionCode, ...ortherData } =
        this.searchPromotionProgramVoucher;
      let listCodeDrugs =
        drugs?.length > 0 ? drugs?.map((el) => el?.drug?.code) : [];
      let listCodeServices =
        paServiceRegister?.length > 0
          ? paServiceRegister?.map((el) => el?.service?.code)
          : [];
      let dataProgram = {};

      if (promotionCode?.length > 0) {
        // tìm theo voucher
        const { data } = await findByPromotionCode({
          promotionCode,
          productServiceCodes: [...listCodeDrugs, ...listCodeServices],
          ...ortherData,
        });

        if (data) {
          dataProgram.content = [data];
        }
      } else {
        const { data } = await pagingProgram({
          pageIndex: 1,
          pageSize: PAGESIZE_ALL,
          productServiceCodes: [...listCodeDrugs, ...listCodeServices],
          ...ortherData,
        });
        dataProgram = data;
      }

      this.promotionPrograms = dataProgram?.content || [];
    } catch (error) {
      console.error("❌ Lỗi khi lấy chương trình khuyến mãi:", error);
      toast.error("Không thể tải chương trình khuyến mãi");
    }
  };

  //dùng ctkm ở popup thanh toán
  handleChangeFormSearchPaymentPromotionProgram = (searchObj) => {
    this.searchPromotionProgramVoucher = {
      ...this.searchPromotionProgramVoucher,
      ...searchObj,
      isPaying: true,
      isGranted: true,
    };
    this.getPaymentPromotionPrograms();
  };

  //dùng ctkm ở popup thanh toán
  getPaymentPromotionPrograms = async () => {
    try {
      let { listCode, promotionCode, ...ortherData } =
        this.searchPromotionProgramVoucher;

      let dataProgram = {};

      if (promotionCode?.length > 0) {
        // tìm theo voucher
        const { data } = await findByPromotionCode({
          promotionCode,
          productServiceCodes: [...listCode],
          ...ortherData,
        });

        if (data) {
          dataProgram.content = [data];
        }
      } else {
        const { data } = await pagingProgram({
          pageIndex: 1,
          pageSize: PAGESIZE_ALL,
          productServiceCodes: [...listCode],
          ...ortherData,
        });
        dataProgram = data;
      }

      this.promotionPrograms = dataProgram?.content || [];
    } catch (error) {
      console.error("❌ Lỗi khi lấy chương trình khuyến mãi:", error);
      toast.error("Không thể tải chương trình khuyến mãi");
    }
  };

  // searchPromotionProgramVoucher
  handleCloseFormFreePromotion = () => {
    this.openFormFreePromotion = false;
    this.searchPromotionProgramVoucher = null;
    this.promotionPrograms = [];
  };

  handleOpenFormFreePromotion = (initialValues) => {
    // nếu có crmuuid  e truyền lên {clientId :crmuuid} nếu không có {clientEmrMappingId  :patientId}

    if (initialValues?.patient?.id) {
      let listBranchCode = [];
      if (initialValues?.department) {
        listBranchCode = [initialValues?.department?.code];
      }

      if (initialValues?.patient?.crmUuid) {
        this.handleChangeFormSearchPaymentPromotionProgram({
          clientId: initialValues?.patient?.crmUuid,
          listBranchCode,
          listCode: initialValues?.listCode,
          voucherPaymentMethod: initialValues?.voucherPaymentMethod,
        });
      } else {
        this.handleChangeFormSearchPaymentPromotionProgram({
          clientEmrMappingId: initialValues?.patient?.id,
          listBranchCode,
          listCode: initialValues?.listCode,
          voucherPaymentMethod: initialValues?.voucherPaymentMethod,
        });
      }
    }

    this.openFormFreePromotion = true;
  };

  handleOpenFormLockRetaind = (data) => {
    let {
      currentInvoiceItemId,
      totalBillPatientPaid,
      totalPerformedTimes,
      totalTreatmentTimes,
      remainingTreatmentTimes,
      quantity,
      amountActuallyPaid,
      service,
      drug,
      clientCard,
    } = data;
    this.openFormLockRetained = true;
    // Tính số tiền lưu trữ mặc định, đảm bảo không vượt quá số tiền đã thanh toán
    let retainedAmount = 0;
    if (totalPerformedTimes != null) {
      // Đơn giá 1 lần phải tính trên số tiền CẦN THU (đã trừ giảm giá + giảm tổng HĐ),
      // không lấy giá niêm yết `price` vì `price` là giá trước giảm giá.
      const netAmount =
        amountActuallyPaid > 0 ? amountActuallyPaid : totalBillPatientPaid;
      const totalTimes =
        totalTreatmentTimes || remainingTreatmentTimes || quantity || 0;
      const unitPrice = totalTimes > 0 ? netAmount / totalTimes : 0;

      const estimatedUsed = (totalPerformedTimes || 0) * (unitPrice || 0);
      const computed = netAmount - estimatedUsed;

      retainedAmount = Math.min(
        totalBillPatientPaid,
        Math.max(0, Number.isFinite(computed) ? computed : totalBillPatientPaid)
      );
    } else {
      retainedAmount = totalBillPatientPaid;
    }
    this.initialLockRetained = {
      id: currentInvoiceItemId,
      retainedAmount: totalBillPatientPaid > 0 ? retainedAmount : 0,
      totalBillPatientPaid,
      amountActuallyPaid,
      totalPerformedTimes,
      service,
      drug,
      clientCard,
    };
  };
  handleCloseFormLockRetaind = () => {
    this.openFormLockRetained = null;
    this.initialLockRetained = null;
  };

  handleLockRetaind = async (obj) => {
    try {
      const { data } = await lockOrder(obj);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Khóa thành công");
      }
      this.openFormLockRetained = null;
      this.initialLockRetained = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleGetListCodeSource = async (obj) => {
    try {
      const { data } = await getListCode(obj);
      runInAction(() => {
        this.listCodeSource = data || [];
      });
    } catch (error) {
      //console.error(error);
    }
  };
  resetStore = () => {
    this.searchVoucherFee = { ...DEFAULT_SEARCH_VOUCHER_FEE };
    this.dataVoucherFee = [];
    this.openConfirmMessage = null;
    this.openConfirmDelete = null;
    this.listPaymentMethod = [];
    this.listStk = [];
    this.editableVoucher = false;
    this.openConfirmError = null;
  };

  resetStorePopup = () => {
    this.dataInvoicePopupFee = null;
    this.editableVoucher = false;
    this.listPos = [];
    this.listStk = [];
    this.listPos_tragop = [];
    this.listHomecredit = [];
  };
}
